import { useMediaQuery } from "usehooks-ts";

import { convertPlayerPrice } from "../../../../../functions/convertPlayerPrice";
import { BREAKPOINTS } from "../../../../../settings";

export const Price = ({
  price,
  priceType,
}: {
  price: number;
  priceType: "sbc" | "market" | "xp";
}) => {
  const isSmallDesktop = useMediaQuery(BREAKPOINTS.SMALL_DESKTOP.query);

  return (
    <div className="flex items-center px-1 m-auto gap-x-1 md-sm:px-2 md-lg:px-8 desktop:px-0 large:px-2">
      <div className="flex w-4 h-4 my-auto mr-1 desktop:w-5 desktop:h-5 touch-device:w-6 touch-device:h-6 touch-device:mr-0 large:mr-1">
        {priceType === "market" ? (
          <img
            src={`${
              import.meta.env.VITE_APP_ASSETS_BASE_URL
            }/fc25/misc/coin.png`}
            alt="ut-coin"
          />
        ) : priceType === "xp" ? (
          <img
            src={`${
              import.meta.env.VITE_APP_ASSETS_BASE_URL
            }/fc25/misc/xp_not_cached.png`}
            alt="ut-coin"
          />
        ) : (
          <img
            className="my-auto"
            src={`${
              import.meta.env.VITE_APP_ASSETS_BASE_URL
            }/fc25/misc/sbc.png`}
            alt="ut-coin"
          />
        )}
      </div>
      {priceType !== "xp" && price !== 0 && (
        <div className="text-xs md-sm:text-sm md-lg:text-base desktop:text-sm large:text-base">
          {convertPlayerPrice(price, isSmallDesktop)}
        </div>
      )}
    </div>
  );
};
